import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';

/**
 * This is to track the contact us form submission mutation keys in react query
 * cache.
 */
const MUT_CONTACT_US = 'contact-us-form-submission-mutation';

interface ISendUserLoginOTPOptions {
  onSuccessCallback: () => void;
  onErrorCallback: (error: IApiError) => void;
}

/**
 * This performs a submit the contact us from data request.
 */
export const useContactUsMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: ISendUserLoginOTPOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_CONTACT_US],
    networkMode: 'always',
    retry: false,
    mutationFn: B2B_SERVICE_API.postContactUsForm,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Error in Submitting Contact Us form',
        message: error?.message,
      });

      onErrorCallback(err);
    },
  });

  return {
    error,
    isPending,
    submitContactUs: mutate,
  };
};
